/*
 * Bestsellers Grid — mobile swipe-arrow control.
 * On mobile the grid becomes a horizontal scroll-snap strip (CSS handles
 * the actual swipe/snap natively); this just lets the arrows advance it
 * by one full card width, since a full-width single card leaves little
 * room to swipe from the screen edges alone.
 */
(function () {
  'use strict';

  var grid = document.getElementById('bestsellersGrid');
  var prevBtn = document.getElementById('bsPrev');
  var nextBtn = document.getElementById('bsNext');
  if (!grid || !prevBtn || !nextBtn) return;

  function scrollByCard(direction) {
    var step = grid.clientWidth; // each card is 100% width on mobile
    grid.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  prevBtn.addEventListener('click', function () { scrollByCard(-1); });
  nextBtn.addEventListener('click', function () { scrollByCard(1); });
})();